import type { PropsWithChildren } from 'react';
import { Box, Flex, Text, useTheme } from '@chakra-ui/react';

import { useIsMobile } from '@izimi/hooks';

import { FileIcon } from '../../../icon';
import { NabanCard } from '../../components/NabanCard';

type Props = {
  title: string;
  onClick?: VoidFunction;
};

export const NabanDeedMainDocument = ({ title, onClick, children }: PropsWithChildren<Props>) => {
  const isMobile = useIsMobile();
  const theme = useTheme();

  return (
    <NabanCard
      onClick={onClick}
      variant='highlight'
      py={{
        base: 6,
        md: 12,
      }}
      px={{
        base: 4,
        md: 8,
      }}
      w='100%'
      flexDirection='row'
      alignItems='center'
      justifyContent='space-between'>
      <Flex flexDirection='row' alignItems='center' gap={{ base: 4, md: 6 }}>
        <Box filter='drop-shadow(1px 4px 8px rgba(0, 0, 0, 0.15))'>
          <FileIcon extension='pdf' color={theme.colors.primary400} size={isMobile ? 32 : 48} />
        </Box>
        <Text variant='heading2' fontSize={{ base: '18px', md: '24px' }}>
          {title}
        </Text>
      </Flex>
      {children}
    </NabanCard>
  );
};
